export default "__VITE_ASSET__cb73a5e6__"